import { pulseTypeFragmentSchema } from "./pulseTypeFragment";
import { searchFilterFragmentSchema } from "./searchFilterFragment";
import { ecommerceTypeFragmentSchema } from "./ecommerceTypeFragment";
import { assetTypeFragmentSchema } from "./assetTypeFragment";
import { ecommerceSourceImpressionFragmentSchema } from "./ecommerceSourceImpressionFragment";
import { videoTypeFragmentSchema } from "./videoTypeFragment";
import { validateAndTriggerEvent } from "../listener";
import { Types } from "../types";
export var viewItemListMeta = {
    "gtm": true,
    "deprecated": false,
    "name": "viewItemList",
    "origName": "viewItemList"
};
var viewItemListContextNames = [];
export var viewItemListEventSchema = Types.object.of({
    ecommerce: Types.object.of({
        type: ecommerceTypeFragmentSchema.isRequired,
        continuousPlay: Types.enum(["", "time elapsed"]).isRequired,
        pulseType: pulseTypeFragmentSchema.isRequired,
        scheduleDate: Types.string.isRequired,
        scheduleFilter: Types.string.isRequired,
        searchTerm: Types.string.isRequired,
        searchFilter: searchFilterFragmentSchema.isRequired,
        items: Types.array.of(Types.object.of({
            item_name: Types.string.isRequired,
            item_id: Types.string.isRequired,
            item_brand: assetTypeFragmentSchema.isRequired,
            item_category: Types.string.isRequired,
            item_category2: Types.string.isRequired,
            item_category3: Types.string.isRequired,
            item_category4: ecommerceSourceImpressionFragmentSchema.isRequired,
            item_category5: Types.bool.isRequired,
            item_competition_id: Types.string.isRequired,
            item_competition_name: Types.string.isRequired,
            item_variant: Types.string.isRequired,
            item_list_name: Types.string.isRequired,
            item_list_id: Types.string.isRequired,
            index: Types.string.isRequired,
            quantity: Types.const(1),
            is_free_to_view: Types.bool,
            video_type: videoTypeFragmentSchema,
            sport_id: Types.string,
            sport_name: Types.string,
        }).isRequired).isRequired,
    }).isRequired,
});
/**
 * Trigger viewItemList event
 *
 * Scope - captures content tile impressions. Triggering condition - event is fired every time there's a tile impression, as defined in the Content Impression Go Live Approach deck.
 *
 * @param {Object} payload
 * @param {Object} payload.ecommerce - string
 * @param {navigation|news|player shoppable ad|pulse|rail|recent search|schedule|search|sports category|up next} payload.ecommerce.type - string
 * @param {(|time elapsed)} payload.ecommerce.continuousPlay - string
 * @param {|end of match|extra time first half|extra time second half|goal|hit the woodwork|kick off|penalty|penalty missed|penalty saved|penalty scored|penalty shootout|red card|second half|var no goal|var no penalty|var no red card} payload.ecommerce.pulseType - string
 * @param {string} payload.ecommerce.scheduleDate - string
 * @param {string} payload.ecommerce.scheduleFilter - string
 * @param {string} payload.ecommerce.searchTerm - string
 * @param {|search all|search calendar|search competitions|search competitors|search events|search features} payload.ecommerce.searchFilter - string
 * @param {Object} payload.ecommerce.items - string
 * @param {string} payload.ecommerce.items[].item_name - string
 * @param {string} payload.ecommerce.items[].item_id - string
 * @param {article|competition|competitor|fixture|news|program|shop|show|sport|subscription} payload.ecommerce.items[].item_brand - string
 * @param {string} payload.ecommerce.items[].item_category - string
 * @param {string} payload.ecommerce.items[].item_category2 - string
 * @param {string} payload.ecommerce.items[].item_category3 - string
 * @param {audiostream impression|competitor impression|editors picks impression|latest news impression|merch fanatics impression|multiview impression|navigation impression|news impression|personalize rail impression|pulse disappear|pulse impression|rail impression|recent search impression|schedule impression|search impression|ticketing daimani impression|tv program impression|up next impression|upcoming fight card impression} payload.ecommerce.items[].item_category4 - string
 * @param {boolean} payload.ecommerce.items[].item_category5 - string
 * @param {string} payload.ecommerce.items[].item_competition_id - string
 * @param {string} payload.ecommerce.items[].item_competition_name - string
 * @param {string} payload.ecommerce.items[].item_variant - string
 * @param {string} payload.ecommerce.items[].item_list_name - string
 * @param {string} payload.ecommerce.items[].item_list_id - string
 * @param {string} payload.ecommerce.items[].index - string
 * @param {(1)} [payload.ecommerce.items[].quantity] - string
 * @param {boolean} [payload.ecommerce.items[].is_free_to_view] - string
 * @param {live|vod} [payload.ecommerce.items[].video_type] - string
 * @param {string} [payload.ecommerce.items[].sport_id] - string
 * @param {string} [payload.ecommerce.items[].sport_name] - string
 * @returns {undefined}
 */
export function triggerViewItemListEvent(payload) {
    return validateAndTriggerEvent(viewItemListMeta, viewItemListEventSchema, payload, viewItemListContextNames);
}
//# sourceMappingURL=viewItemListEvent.js.map